var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartSession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.9878C18.5676 23.9878 24 18.5554 24 11.9878C24 5.42014 18.5554 0 11.9878 0C5.42014 0 0 5.42014 0 11.9878C0 18.5554 5.43235 23.9878 12 23.9878ZM9.7294 16.7487C9.16785 17.0905 8.49644 16.7976 8.49644 16.1994V7.7884C8.49644 7.20244 9.20448 6.92167 9.7294 7.23906L16.6999 11.3286C17.2004 11.6338 17.2126 12.3662 16.6999 12.6714L9.7294 16.7487Z",
    fill: "#F3A952"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartSession);
export default __webpack_public_path__ + "static/media/start-session.668feea67a08decbdcae6d20dc93ee14.svg";
export { ForwardRef as ReactComponent };